import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { createStackNavigator } from '@react-navigation/stack';
import Documents from '../pages/documents/Documents';
import { DocumentsSchemas } from '../schemas/documents';
import { DocumentsParamList } from '../typings/Params';
import { Module } from '../Routes';

export const documentsModule: Module<'Documents'> = {
    path: '/documents',
    stackNavigator: createStackNavigator<DocumentsParamList>(),
    canAccess: (user, currentApp) => Boolean(!currentApp.isAgentApp && (user?.isAdmin || user?.permissions.documents_module_access)),
    icon: require('../../assets/icon_documents.png'),
    logo: require('../../assets/logo_documents.png'),
    label: 'documents',
    navigate: (navigation) => navigation.navigate('Documents'),
    schemas: DocumentsSchemas,
    screens: {
        Documents: {
            path: 'documents',
            selectedItem: 'documents',
            component: Documents,
            label: 'documents',
            canAccess: () => true,
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'Documents' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        }
    },
};
